import { useMemo } from 'react';
// FE-4406: useHasActiveSSSAccount hidden — re-add later when earn dropdown is restored
// import { useHasActiveSSSAccount } from 'src/components/Navigation/hooks/useHasActiveSSSAccount';
import {
	NavigationCategory,
	// FE-4406: NavigationOptionKey / MobileCategoryOption / DesktopCategoryOption hidden — re-add later
	// NavigationOptionKey,
	// MobileCategoryOption,
	MobileNavigationOption,
	// DesktopCategoryOption,
	DesktopNavigationOption,
} from 'src/components/Navigation/types';
import {
	getMobileNavigationOptions,
	getDesktopNavigationOptions,
} from 'src/components/Navigation/config/consts';
import { usePrivyWalletContext } from 'src/providers/wallets/PrivyWalletProvider';

type ScreenSize = 'mobile' | 'desktop';

type Params<T extends ScreenSize = ScreenSize> = { screenSize: T };

type UseNavItems<T> = [
	NavigationCategory,
	T extends 'mobile' ? MobileNavigationOption : DesktopNavigationOption,
][];

export default function useNavItems<T extends ScreenSize>({
	screenSize,
}: Params<T>): UseNavItems<T> {
	// FE-4406: hasActiveSSSAccount hidden — re-add later when earn dropdown is restored
	// const hasActiveSSSAccount = useHasActiveSSSAccount();
	const { isPrivyNativeAuth } = usePrivyWalletContext();

	const navOptionsToUse = useMemo(() => {
		return screenSize === 'mobile'
			? getMobileNavigationOptions({ isPrivyNativeAuth })
			: getDesktopNavigationOptions({ isPrivyNativeAuth });
	}, [screenSize, isPrivyNativeAuth]);

	return useMemo((): UseNavItems<T> => {
		const navOptionEntries = Object.entries(navOptionsToUse) as UseNavItems<T>;

		return navOptionEntries
			.filter(([, navOption]) => !navOption.hideCondition)
			.map(([navigationCategory, navOption]) => {
				// FE-4406: SSS account filtering hidden — re-add later when earn dropdown is restored
				// const categoryName = navOption.categoryName;
				// if (categoryName === 'earn' && navOption.type === 'categoryOption') {
				// 	if (hasActiveSSSAccount) {
				// 		return [navigationCategory, navOption];
				// 	}
				// 	const updatedNavOption = getOptionsFilteredByKey(
				// 		navOption,
				// 		'superstakesol'
				// 	);
				// 	return [navigationCategory, updatedNavOption];
				// }

				return [navigationCategory, navOption];
			});
	}, [navOptionsToUse]);
}

// FE-4406: getOptionsFilteredByKey hidden — re-add later when earn dropdown is restored
// function getOptionsFilteredByKey<
// 	T extends MobileCategoryOption | DesktopCategoryOption,
// >(option: T, key: NavigationOptionKey) {
// 	const filteredOptions = option.options.filter(
// 		(categoryOption) => categoryOption.key !== key
// 	);
// 	return {
// 		...option,
// 		options: filteredOptions,
// 	};
// }
